import { Node, mergeAttributes } from "@tiptap/core";
import { VueNodeViewRenderer } from "@tiptap/vue-3";
import RepeatSectionView from "@/features/document-editor/ui/RepeatSectionView.vue";

export const RepeatSectionNode = Node.create({
  name: "repeatSection",
  group: "block",
  content: "block+",
  defining: true,
  isolating: true,
  selectable: true,
  draggable: false,

  addAttributes() {
    return {
      placeholderCode: {
        default: "",
        parseHTML: (el) => el.getAttribute("data-placeholder-code"),
        renderHTML: (attrs) => ({
          "data-placeholder-code": attrs.placeholderCode,
        }),
      },
      label: {
        default: "",
        parseHTML: (el) => el.getAttribute("data-label"),
        renderHTML: (attrs) => ({
          "data-label": attrs.label,
        }),
      },
      sectionOrder: {
        default: null,
        parseHTML: (el) => {
          const val = el.getAttribute("data-section-order");
          return val !== null ? parseInt(val, 10) : null;
        },
        renderHTML: (attrs) => ({
          "data-section-order":
            attrs.sectionOrder !== null ? String(attrs.sectionOrder) : null,
        }),
      },
    };
  },

  addOptions() {
    return {
      mode: "edit",
      allowUnwrap: true,
    };
  },

  parseHTML() {
    return [
      {
        tag: "div[data-repeat-section]",
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      "div",
      mergeAttributes(HTMLAttributes, {
        "data-repeat-section": "",
      }),
      0,
    ];
  },

  addNodeView() {
    return VueNodeViewRenderer(RepeatSectionView);
  },

  addCommands() {
    return {
      wrapInRepeatSection:
        (attrs) =>
        ({ chain }) => {
          return chain().wrapIn(this.name, attrs).run();
        },
      unwrapRepeatSection:
        () =>
        ({ chain }) => {
          return chain().lift(this.name).run();
        },
    };
  },
});
